import { combineEpics } from 'redux-observable';
import { getRecordLabelsEpic } from './get-record-label';
import { createRecordLabelsEpic } from './create-record-label';
import { deleteRecordLabelsEpic } from './delete-record-label';
import { getLabelsAfterLoginEpic } from './get-after-login';
import { autosaveEpic } from './autosave';
import { updateRecordLabelEpic } from './update-record-label';
import { attachArtistRecordLabelsEpic } from './attach-artist-record-label';
import { attachNewArtistEpic } from './attach-new-artist';
import { removeArtistRecordLabelsEpic } from './remove-artist-record-label';
import { updateArtistCountEpic } from './update-artist-count';
import { listRecordLabelArtistsEpic } from './list-record-label-artists';
import { autosaveRelationEpic } from './autosave-relation';
import { updateRecordLabelRelationEpic } from './update-record-label-relation';
import { getArtistRecordLabelsEpic } from './get-artist-record-labels';
import { listOperatorsEpic } from './list-operators';
import { createOperatorEpic } from './create-operator';
import { deleteOperatorEpic } from './delete-operator';
import { inviteRecordLabelEpic } from './create-record-label-invite';
import { inviteOperatorEpic } from './create-operator-invite';
import { setActiveEpic } from './set-active';
import { updateLastActiveLabelEpic } from './update-last-active';
import { createRecordLabelOnboardingEpic } from './create-record-label-onboarding';
import { getActiveArtistLabelsEpic } from './get-active-artist-label';
import { onboardingSuccessSetActiveEpic } from './onboarding-success-set-active';
import { onboardingSuccessSendInvitesEpic } from './onboarding-success-send-invites';
import { getLabelsAfterCreateEpic } from './get-after-create';
import { onboardingSuccessRedirectEpic } from './onboarding-success-redirect';
import { subscriptionSuccessSetActiveEpic } from './subscription-success-set-active';
import { listArtistsAfterLoadEpic } from './list-artists-after-load';
import { downgradeRecordLabelsEpic } from './downgrade-record-label';
import { downgradeSuccessRedirectEpic } from './downgrade-success';
import { restoreRecordLabelsEpic } from './restore-record-label';
import { attachArtistAfterCreateRosterEpic } from './attach-artists-new-record-label';
import { attachArtistAfterUpdateRosterEpic } from './attach-artists-update-record-label';

const recordLabelsEpic = combineEpics(
  getRecordLabelsEpic,
  createRecordLabelsEpic,
  deleteRecordLabelsEpic,
  getActiveArtistLabelsEpic,
  autosaveEpic,
  autosaveRelationEpic,
  updateRecordLabelEpic,
  attachArtistRecordLabelsEpic,
  removeArtistRecordLabelsEpic,
  restoreRecordLabelsEpic,
  updateArtistCountEpic,
  listRecordLabelArtistsEpic,
  updateRecordLabelRelationEpic,
  getArtistRecordLabelsEpic,
  listOperatorsEpic,
  createOperatorEpic,
  deleteOperatorEpic,
  inviteRecordLabelEpic,
  inviteOperatorEpic,
  setActiveEpic,
  updateLastActiveLabelEpic,
  createRecordLabelOnboardingEpic,
  getLabelsAfterLoginEpic,
  listArtistsAfterLoadEpic,
  onboardingSuccessSetActiveEpic,
  onboardingSuccessSendInvitesEpic,
  getLabelsAfterCreateEpic,
  onboardingSuccessRedirectEpic,
  subscriptionSuccessSetActiveEpic,
  attachNewArtistEpic,
  downgradeRecordLabelsEpic,
  downgradeSuccessRedirectEpic,
  attachArtistAfterCreateRosterEpic,
  attachArtistAfterUpdateRosterEpic
);

export default recordLabelsEpic;
